import 'angular:locale/data:uk';
import 'zone.js';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
